export default {
    reviewOrder: {
        reviewOrder: "Pedido em revisão"
    }
}